import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { KanbanCard } from './KanbanCard';

export function KanbanColumn({ id, title, orders, colorClass, onUpdate }) {
    const { isOver, setNodeRef } = useDroppable({
        id: id,
    });

    return (
        <div className="flex flex-col min-w-[320px] w-[320px] bg-[var(--bg-card)] border border-[var(--border-color)] rounded-2xl h-full max-h-[75vh]">
            <div className={`p-4 border-b border-[var(--border-color)] ${colorClass} rounded-t-2xl flex justify-between items-center bg-[var(--bg-main)]/50`}>
                <h3 className="font-black uppercase text-xs tracking-widest">{title}</h3>
                <span className="bg-[var(--bg-main)] px-2 py-1 rounded-md text-[10px] font-bold text-[var(--text-primary)]">{orders.length}</span>
            </div>
            
            <div 
                ref={setNodeRef} 
                className={`flex-1 overflow-y-auto p-4 transition-colors no-scrollbar ${isOver ? 'bg-[var(--accent-color)]/5' : ''}`}
            >
                {orders.map(order => (
                    <KanbanCard key={order._id} order={order} colId={id} onUpdate={onUpdate} />
                ))}
                {orders.length === 0 && (
                    <div className="h-full flex flex-col items-center justify-center opacity-20 text-[10px] font-black uppercase tracking-widest text-center border-2 border-dashed border-[var(--border-color)] rounded-xl p-4 text-[var(--text-primary)]">
                        {id === 'col-pendentes' ? (
                            <span>Logo teremos<br/>mais pedidos...</span>
                        ) : (
                            <span>Nenhum Alvo<br/>Nesta Zona</span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
